<template>
	<SortableListAdder :invalid="!valid" :busy="uploading" @add="add">
		<div class="form">
			<div class="file" :style="previewStyle">
				<input type="file" name="file" @change="onFile" />
				<IconUpload v-if="!preview" class="icon" />
			</div>
			<FieldInput name="name" class="name" placeholder="Prize name" v-model="name" />
		</div>
	</SortableListAdder>
</template>

<script>
import { mapActions } from 'vuex'
import IconUpload from 'mdi-vue/ImagePlus'
import SortableListAdder from '@/components/SortableListAdder'
import FieldInput from '@/components/FieldInput'
import api from '@/lib/api'

export default {
	name: 'AddPrizeForm',
	props: {
		prizes: Array,
	},
	data() {
		return {
			uploading: false,
			file: null,
			name: '',
			reader: new FileReader(),
			preview: null,
		}
	},
	computed: {
		valid() {
			return (
				this.file &&
				this.name &&
				this.prizes.every(prize => {
					return prize.name !== this.name
				})
			)
		},
		previewStyle() {
			if (this.preview) {
				return {
					backgroundImage: `url("${this.preview}")`,
				}
			} else {
				return {}
			}
		},
	},
	methods: {
		...mapActions({
			toast: 'toast/push',
		}),
		onFile(event) {
			this.file = event.target.files[0]
			this.reader.readAsDataURL(this.file)
		},
		createPreview(event) {
			this.preview = event.target.result.replace(/(\r\n|\r|\n)/gm)
		},
		async add() {
			if (this.valid && !this.uploading) {
				// Upload file to get its URL
				this.uploading = true

				try {
					// Emit add prize event with file name and URL
					const res = await api.upload('/upload', this.file)
					this.$emit('add', {
						name: this.name,
						url: res.url,
					})

					// Reset form
					this.file = null
					this.preview = null
					this.name = ''
				} catch (err) {
					this.toast({
						message: 'Failed to upload image.',
					})
				}

				// Reset uploading flag
				this.uploading = false
			}
		},
	},
	mounted() {
		this.reader.onload = this.createPreview
	},
	components: {
		SortableListAdder,
		IconUpload,
		FieldInput,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

.form {
	@extend %flex-row;
	padding: 0.5rem;
	@include not-last {
		margin-right: 0.5rem;
	}

	.file {
		@include circle(7.5rem);
		position: relative;
		background-color: $col-primary;
		background-size: cover;
		background-position: center;

		$plus-width: 2.5rem;
		$plus-height: 0.5rem;

		input {
			width: 100%;
			height: 100%;
			opacity: 0;
			cursor: pointer;
		}

		.icon {
			position: absolute;
			color: $white;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%) scale(2);
			pointer-events: none;
		}
	}

	.name {
		flex-grow: 1;
		::v-deep input {
			background-color: $white;
		}
	}
}
</style>
